import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Container } from '@teko/ui';
import { Flex, Box } from 'reflexbox';
import { FooterBlock } from './components/FooterBlock/FooterBlock.es.js';

const FooterWrapper = styled.div(({ theme }) => `
  @media print {
    display: none;
  }
  border-top: solid 3px ${theme == null ? void 0 : theme.brand.primary};
  position: relative;
`);
const Wrapper = styled.nav(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  padding: 1rem 0;
`);
const StyledContainer = styled(Container)`
  display: flex;
  margin-bottom: 10px;
`;
const ColumnInnerLine = styled.div`
  font-size: 12px;
  width: 100%;
  padding-right: 8px;
  a {
    color: #333;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  span {
    line-height: 1.5rem;
  }
`;
const StyledWrapper = styled(Wrapper)(({ customBottomColor, theme }) => `
  background-color: ${customBottomColor && (theme == null ? void 0 : theme.colors[customBottomColor]) || "#e9edf2"};
  margin-top: -10px;
  padding-top: 30px;
  padding-bottom: 25px;
`);
const CompanyName = styled.div`
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 15px;
`;
const BranchName = styled.span`
  font-size: 12px;
  font-weight: bold;
`;
const StyledImg = styled.img`
  width: 100%;
  max-width: 160px;
`;
const StyledLink = styled.a`
  display: block;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;
const StyledDMCA = styled.div`
  margin-top: 0.5rem;
  img {
    width: 100%;
    max-width: 100px;
  }
`;
const Description = styled.p`
  font-size: 0.75rem;
  text-align: center;
  margin: 0;
`;
const getResponsiveWidth = (col) => {
  switch (col) {
    case 2:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 2];
    case 3:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 3];
    case 4:
      return [1 / 2, 1 / 2, 1 / 2, 1 / 4];
    default:
      return [1 / 2, 1 / 3, 1 / 3, 1 / 5];
  }
};
const Footer = ({
  footer,
  customBottomColor,
  baseUrl
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  return /* @__PURE__ */ React.createElement(FooterWrapper, null, (footer.bankList || footer.supportAndPolicy || footer.paymentMethods) && /* @__PURE__ */ React.createElement(Wrapper, null, footer.supportAndPolicy && /* @__PURE__ */ React.createElement(StyledContainer, null, /* @__PURE__ */ React.createElement(Flex, {
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%"
  }, footer.supportAndPolicy.map((column, index) => {
    return /* @__PURE__ */ React.createElement(Box, {
      width: !!footer.supportAndPolicy ? getResponsiveWidth(footer.supportAndPolicy.length) : void 0,
      key: index
    }, /* @__PURE__ */ React.createElement(FooterBlock, {
      title: column.title,
      links: column.links,
      emails: column.emails,
      phones: column.phones,
      image: column.image,
      isLogoImage: true
    }));
  }))), /* @__PURE__ */ React.createElement(StyledContainer, null, /* @__PURE__ */ React.createElement(Flex, {
    flexWrap: "wrap"
  }, footer.paymentMethods && /* @__PURE__ */ React.createElement(Box, {
    width: [1, 1, "40%"]
  }, /* @__PURE__ */ React.createElement(FooterBlock, {
    title: footer.paymentMethods.title,
    links: footer.paymentMethods.links,
    flexDir: "column",
    btnBlock: false
  })), footer.bankList && /* @__PURE__ */ React.createElement(Box, {
    width: [1, 1, "60%"]
  }, /* @__PURE__ */ React.createElement(FooterBlock, {
    title: t("Danh s\xE1ch c\xE1c ng\xE2n h\xE0ng thanh to\xE1n online"),
    image: footer.bankList.imgSrc
  }))))), footer.bottom && /* @__PURE__ */ React.createElement(StyledWrapper, {
    customBottomColor
  }, /* @__PURE__ */ React.createElement(StyledContainer, null, /* @__PURE__ */ React.createElement(Flex, {
    flexWrap: "wrap",
    width: "100%"
  }, /* @__PURE__ */ React.createElement(Box, {
    width: [1, "50%", "35%", "40%"]
  }, ((_a = footer.bottom) == null ? void 0 : _a.company) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CompanyName, null, (_b = footer.bottom) == null ? void 0 : _b.company.name), /* @__PURE__ */ React.createElement(ColumnInnerLine, {
    dangerouslySetInnerHTML: {
      __html: (_c = footer.bottom) == null ? void 0 : _c.company.detail
    }
  }))), /* @__PURE__ */ React.createElement(Box, {
    width: [1, "50%", "35%", "40%"]
  }, footer.bottom.address && footer.bottom.address.map((addressDetail) => {
    return /* @__PURE__ */ React.createElement("div", {
      key: addressDetail.branchName
    }, /* @__PURE__ */ React.createElement(BranchName, null, addressDetail.branchName), ":", /* @__PURE__ */ React.createElement(ColumnInnerLine, null, addressDetail.branchAddress));
  }), footer.bottom.phone && footer.bottom.email && /* @__PURE__ */ React.createElement(ColumnInnerLine, null, `${t("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i")}: ${footer.bottom.phone} - Email: ${footer.bottom.email} `)), /* @__PURE__ */ React.createElement(Box, {
    width: [1, "100%", "30%", "20%"]
  }, !!((_e = (_d = footer == null ? void 0 : footer.bottom) == null ? void 0 : _d.registeredLogo) == null ? void 0 : _e.logo) && /* @__PURE__ */ React.createElement(StyledLink, {
    href: (_f = footer.bottom.registeredLogo) == null ? void 0 : _f.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ React.createElement(StyledImg, {
    src: footer.bottom.registeredLogo.logo,
    alt: "registered logo"
  })), !!((_h = (_g = footer == null ? void 0 : footer.bottom) == null ? void 0 : _g.verifiedLogo) == null ? void 0 : _h.logo) && /* @__PURE__ */ React.createElement(StyledLink, {
    href: (_i = footer.bottom.verifiedLogo) == null ? void 0 : _i.link,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ React.createElement(StyledImg, {
    src: footer.bottom.verifiedLogo.logo,
    alt: "verified logo"
  })), ((_j = footer == null ? void 0 : footer.bottom) == null ? void 0 : _j.dmcaBadgeLink) && ((_k = footer == null ? void 0 : footer.bottom) == null ? void 0 : _k.dmcaId) && /* @__PURE__ */ React.createElement(StyledDMCA, null, /* @__PURE__ */ React.createElement("a", {
    href: `//www.dmca.com/Protection/Status.aspx?ID=${(_l = footer == null ? void 0 : footer.bottom) == null ? void 0 : _l.dmcaId}&refurl=${baseUrl}`,
    title: "DMCA.com Protection Status",
    className: "dmca-badge"
  }, /* @__PURE__ */ React.createElement("img", {
    src: `${(_m = footer == null ? void 0 : footer.bottom) == null ? void 0 : _m.dmcaBadgeLink}?ID=${(_n = footer == null ? void 0 : footer.bottom) == null ? void 0 : _n.dmcaId}`,
    alt: "DMCA.com Protection Status"
  })))), /* @__PURE__ */ React.createElement(Box, {
    width: [1]
  }, ((_o = footer == null ? void 0 : footer.bottom) == null ? void 0 : _o.description) && /* @__PURE__ */ React.createElement(Description, {
    dangerouslySetInnerHTML: {
      __html: footer.bottom.description
    }
  }))))));
};

export { Footer };
